import {daysDurationFormat, durationFormat, minutesDurationFormat, secondsDurationFormat} from '../config/moment';

export const formatDuration = (duration, format) => duration.format(format, {
  useToLocaleString: false,
  groupingSeparator: '\'',
  trim: false,
});

export const formatDurationShort = (duration) => {
  if (duration.days() > 0) {
    return formatDuration(duration, daysDurationFormat);
  }
  if (duration.hours() > 0) {
    return formatDuration(duration, durationFormat);
  }
  if (duration.minutes() > 0) {
    return formatDuration(duration, minutesDurationFormat);
  }
  return formatDuration(duration, secondsDurationFormat);
};
